<script lang="ts" setup>
import { FontAwesomeIcon } from '@shared/plugin/icons';
import { computed, ref, toRefs, watch } from 'vue';

import VModal from '../VModal/VModal.vue';
import { ModalType } from '../types';

const props = defineProps<{
  isTimedout: boolean;
  isCloseToTimeout: boolean;
  secondsUntilTimeout: number;
  isTemporaryUser?: boolean;
}>();

const emit = defineEmits<{
  continueSession: [];
  handleSignOut: [];
}>();

const { secondsUntilTimeout, isTimedout, isTemporaryUser, isCloseToTimeout } = toRefs(props);

const show = ref(false);

const timeString = computed(() => {
  if (secondsUntilTimeout.value <= 1) return 'nu';
  if (secondsUntilTimeout.value > 120)
    return `over ${Math.round(secondsUntilTimeout.value / 60)} minuten`;
  if (secondsUntilTimeout.value > 60) return `over 1 minuut`;
  return `over ${secondsUntilTimeout.value} seconden`;
});

const denyButtonText = computed(() => {
  if (isTimedout.value) return '';
  return isTemporaryUser.value ? 'Verlaten' : 'Uitloggen';
});

const confirmButtonText = computed(() => {
  if (isTimedout.value) return isTemporaryUser.value ? '' : 'Opnieuw inloggen';
  return 'Sessie verlengen';
});

watch(
  () => isCloseToTimeout.value,
  (value) => {
    show.value = value;
  },
  { immediate: true },
);

function onContinue() {
  show.value = false;
  emit('continueSession');
}
</script>

<template>
  <VModal
    v-if="show"
    :is-active="show"
    :type="ModalType.Success"
    :title="isTimedout ? 'Sessie verlopen' : 'Je sessie verloopt'"
    :confirm-button-text
    :deny-button-text
    cancel-button-text=""
    @deny-action="emit('handleSignOut')"
    @confirm-action="onContinue()"
  >
    <div class="pt-3 text-center">
      <FontAwesomeIcon icon="fa-solid fa-exclamation-triangle" size="3x" class="pb-6 text-orange" />
      <p v-if="!isTimedout">
        Je sessie verloopt {{ timeString }}. Verleng je sessie om ingelogd te blijven.
      </p>
      <p v-else-if="!isTemporaryUser">
        Je sessie is verlopen. Klik op 'opnieuw inloggen' om opnieuw in te loggen en terug te keren
        waar je gebleven was.
      </p>
      <p v-else>Je sessie is verlopen. Open deze pagina opnieuw om door te gaan.</p>
    </div>
  </VModal>
</template>
